module.exports = __webpack_public_path__ + "img/list-pattern3.2b0e185.svg";